import upperFirst from 'lodash/upperFirst';

export function getEnvironment() {
  const parts = window?.location.hostname.split('.');

  if (parts.length === 2) {
    return 'production';
  }

  const env = parts[0] === 'app' ? parts[1] : parts[0];
  return upperFirst(env);
}

export const isProduction = getEnvironment() === 'production';
